import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import RaddissonSelection from "../Selection2/radissonSelection";
import RadissonShow from "./commercialimagesshow/RadissonShow";
import UnodcSelection from "../Selection2/unodcSelection";
import UnoDcShow from "./commercialimagesshow/UnoDcShow";

export default function UnoDcCentreComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/3UNODCRegionalCentre/TRAINING HALLS/1.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">
                UNODC Regional Centre
                <br />
                for Combating Cybercrime
              </p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization,
                  Fit-Out, Project Execution
                </span>
                <span>project duration: 3 months</span>
                <span>year of completion: 2024</span>
                <span>project location: Lusail, Doha-QATAR</span>
              </div>
            </div>
          </div>
        </section>

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "35px",
                  textTransform: "uppercase",
                  padding: "50px",
                }}
              >
                State-of-the-art design for the UN Cybercrime Center in Lusail,
                featuring modern classrooms, efficient spaces, and advanced
                technology.
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/3UNODCRegionalCentre/BUFFET/8.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              {/* <ParallaxImage
                src="../../Images/CommercialImages/3UNODCRegionalCentre/BUFFET/5.png"
                alt=""
              /> */}
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                UNITED
                <br />
                NATIONS
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                REGIONAL
                <br />
                CENTRE{" "}
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                TRAINING
                <br />
                Excellence
              </h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "550px",
                zoom: "90%",
              }}
            >
              This project involved the interior design and fit-out of the
              United Nations Regional Centre for Combating Cybercrime, a
              cutting-edge training and administrative facility in Lusail,
              Qatar. Spread across 200 square meters, the design aimed to create
              a cohesive and highly functional environment tailored to the
              specific needs of this international organization.
              <br />
              <br />
              The Training Centre features two fully equipped classrooms, a
              welcoming reception area, a contemporary dining space, and a
              compact yet efficient administrative office. The design concept
              blends modern minimalism with practical efficiency, ensuring
              integration of technology and user-centric spaces.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img"
              
              >
                <ParallaxImage
                  src="../../Images/CommercialImages/3UNODCRegionalCentre/OFFICE/3b.jpg"
                  alt=""
                  
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <UnodcSelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/3UNODCRegionalCentre/TRAINING HALLS/2b.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                Designing a forward-thinking space for innovation and
                collaboration at the UNODC Regional Centre in Lusail, Qatar
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <UnoDcShow/>
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
